import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { ApolloLink, concat, split } from "apollo-link";
import { WebSocketLink } from "apollo-link-ws";
import { getMainDefinition } from "apollo-utilities";
import { withClientState } from "apollo-link-state";
import Cookies from "js-cookie";



const cache = new InMemoryCache();
const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      Authorization: `Bearer ${Cookies.get("sessionId")}`,
    },
  });
  return forward(operation);
});

const httpLink = new HttpLink({
  uri:
    process.env.NODE_ENV === "development"
      ? "http://localhost:4000"
      : "https://youtubebackend.herokuapp.com",
});

const wsLink = new WebSocketLink({
  uri:
    process.env.NODE_ENV === "development"
      ? "ws://localhost:4000"
      : "wss://youtubebackend.herokuapp.com",
  reconnect: true,
  options: {
    reconnect: true,
    connectionParams: () => ({
      // "X-JWT": getToken()
      Authorization: `Bearer ${Cookies.get("sessionId")}`,
    }),
  },
});

const combinedLinks = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === "OperationDefinition" && operation === "subscription";
  },
  wsLink,
  httpLink
);

const errorLink = onError(({ graphQLErrors, networkError, response }) => {
  if (graphQLErrors) {
    graphQLErrors.map(async ({ message, locations, path }) => {
       if (message === "unAutorized") {
         Cookies.remove("sessionId");
         cache.writeData({
           data: {
             auth: {
               __typename: "Auth",
               isLoggedIn: false,
             },
           },
         });
         // response.errors = undefined;
         await client.clearStore();
         window.location= "/"
       }
      console.error(
        `Unexpected error: Message: ${message} Location: ${locations}, Path: ${path}`
      );
      return;
    });
  }
  if (networkError) {
    console.error(`Network error: ${networkError}`);
  }
});


const localStateLink = withClientState({
  cache,
  defaults: {
    auth: {
      __typename: "Auth",
      isLoggedIn: Boolean(Cookies.get('sessionId') || false)
    }
  },
  resolvers: {
    Mutation: {
      logUserIn: (_, { token }, { cache: appCache }) => {
        Cookies.set('sessionId', token, { expires: 7 })
        appCache.writeData({
          data: {
            auth: {
              __typename: "Auth",
              isLoggedIn: true
            }
          }
        });
        return null;
      },
      logUserOut: async (_, __, { cache: appCache }) => {
        Cookies.remove('sessionId')
        appCache.writeData({
          data: {
            auth: {
              __typename: "Auth",
              isLoggedIn: false
            }
          }
        });
        await client.clearStore();
        window.location = "/";
        return null;
      }
    }
  }
});

const client = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    localStateLink,
    concat(authMiddleware, combinedLinks),
  ]),
  cache,
});

export default client;
